import React from "react";
import AddObservaForm from "./AddObservaForm";

const AddObserva = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Observaciones"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddObservaForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddObserva;
